export default __webpack_public_path__ + "19ae44dd3e5cf81fdf988c20cdab6961.jpg";